import { post,downloadStreamFile } from './http'

const baseUrl = '/api/meas/admin'
// 获取班级列表
export const getClassList = data => post(`${baseUrl}/teach/class/getClassList`, data)
// 修改班级状态
export const updateClassStatus = data => post(`${baseUrl}/teach/class/updateClassStatus`, data)
// 获取班级详情/分享
export const getClassDetails = data => post(`${baseUrl}/teach/class/getClassDetails`, data)
// 获取课程信息列表
export const getCourseList = data => post(`${baseUrl}/teach/course/getCourseList`, data)
// 新增/编辑班级
export const saveClass = data => post(`${baseUrl}/teach/class/saveClass`, data)
// 班级详情顶部信息
export const getClassInfo = data => post(`${baseUrl}/teach/class/getClassInfo`, data)
// 校区下来
export const getCampusList = data => post(`${baseUrl}/resource/campus/getCampusList`, data)

// 已报名学员或者未通过下拉
export const getClassStudentListBySelect = data => post(`${baseUrl}/teach/class/getClassStudentListBySelect`, data)
// 学员下拉
export const getStudentListBySelect = data => post(`${baseUrl}/teach/class/getStudentListBySelect`, data)
// 获取学员列表
export const getClassStudentList = data => post(`${baseUrl}/teach/student/getClassStudentList`, data)
// 修改学员状态
export const updateStudentStatus = data => post(`${baseUrl}/teach/student/updateStudentStatus`, data)
// 修改课程信息
export const updateCourseStatus = data => post(`${baseUrl}/teach/course/updateCourseStatus`, data)
// 新增修改课程信息
export const saveCourse = data => post(`${baseUrl}/teach/course/saveCourse`, data)
// 获取课程信息详情
export const getCourseDetails = data => post(`${baseUrl}/teach/course/getCourseDetails`, data)
// 获取课程列表下拉数据
export const getCourseListBySelect = data => post(`${baseUrl}/resource/system/getCourseListBySelect`, data)
// 获取学情列表（考勤接口）
export const getStudyListByClass = data => post(`${baseUrl}/teach/study/getStudyListByClass`, data)
// 作业列表
export const getCourseExamList = data => post(`${baseUrl}/teach/courseexam/getCourseExamList`, data)

// 考试配置列表
export const getCoursExamConfigList = data => post(`${baseUrl}/teach/examconfig/getCoursExamConfigList`, data)
// 新增/编辑/详情考试配置
export const saveCourseExamConfig = data => post(`${baseUrl}/teach/examconfig/saveCourseExamConfig`, data)
// 删除考试配置
export const updateCourseExamConfigStatus = data => post(`${baseUrl}/teach/examconfig/updateCourseExamConfigStatus`, data)

// 获取考试配置详情
export const getCourseExamConfigDetail = data => post(`${baseUrl}/teach/examconfig/getCourseExamConfigDetail`, data)
// 下拉获取题库
export const getQuesBankListBySelect = data => post(`${baseUrl}/resource/system/getQuesBankListBySelect`, data)
// 学员列表/学习情况列表
export const getStudentStudyListByCourse = data => post(`${baseUrl}/teach/study/getStudentStudyListByCourse`, data)
export const getStudentStudyList = data => post(`${baseUrl}/teach/study/getStudentStudyList`, data)
// 获取课时列表
export const getCourseperiodList = data => post(`${baseUrl}/teach/courseperiod/getCourseperiodList`, data)

// 获取作业/考试详情（批阅）
export const getCourseExamDetails = data => post(`${baseUrl}/teach/courseexam/getCourseExamDetails`, data)
// 作业/考试批阅
export const readOverCourseExam = data => post(`${baseUrl}/teach/courseexam/readOverCourseExam`, data)

// 获取课表信息，表格模式
export const getScheduleByTable = data => post(`${baseUrl}/teach/courseperiod/getScheduleByTable`, data)
// 保存规则排课
export const saveRuleCourse = data => post(`${baseUrl}/teach/course/saveRuleCourse`, data)
// 保存日历排课
export const saveSchedule = data => post(`${baseUrl}/teach/course/saveSchedule`, data)
// 获取班级下拉
export const getClassListBySelect = data => post(`${baseUrl}/teach/class/getClassListBySelect`, data)

// 时段下拉
export const getTimeconfigList = data => post(`${baseUrl}/system/time/getTimeconfigList`, data)
// 授课老师下拉
export const getTeacherList = data => post(`${baseUrl}/resource/teacher/getTeacherList`, data)

//编辑保存课时
export const saveCourseperiod = data => post(`${baseUrl}/teach/courseperiod/saveCourseperiod`, data)
// 获取课件下拉
export const getCourseWareListBySelect = data => post(`${baseUrl}/resource/system/getCourseWareListBySelect`, data)
// 获取课时信息
export const getCourseperiodDetails = data => post(`${baseUrl}/teach/courseperiod/getCourseperiodDetails`, data)
// 修改课时状态
export const updateCourseperiodStatus = data => post(`${baseUrl}/teach/courseperiod/updateCourseperiodStatus`, data)
// 顺延课时
export const delayCourseperiod = data => post(`${baseUrl}/teach/courseperiod/delayCourseperiod`, data)
// 课程下拉带预览
export const getRecordedVideoBySelect = data => post(`${baseUrl}/teach/course/getRecordedVideoBySelect`, data)
// 学员信息导出
export const exportStudentStudyList = (data, filename) => downloadStreamFile(`${baseUrl}/teach/study/exportStudentStudyList`, data, filename)
// 课时信息导出
export const exportCourseperiod = (data, filename) => downloadStreamFile(`${baseUrl}/teach/courseperiod/exportCourseperiod`, data, filename)





